import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import app from './app'
import appConfig from './app-config'
import verticalMenu from './vertical-menu'
import driverTicket from './modules/driverTicket'
import support from './modules/support'
import extraFees from './modules/extraFees'
import manifestsPickup from './modules/manifestsPickup'
import paymentSousTraitance from './modules/paymentSousTraitance'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    appConfig,
    verticalMenu,
    driverTicket,
    support,
    extraFees,
    manifestsPickup,
    paymentSousTraitance,
  },
  strict: process.env.DEV,
})
